module.exports = require("./factory")("g");



//////////////////
// WEBPACK FOOTER
// C:/Work/repo/metabase/metabase_wh/node_modules/gen-css-identifier/index.js
// module id = 1974
// module chunks = 7